import React, { FC, ReactNode } from 'react'
import { createAppTheme } from '../../theme'
import { ThemeProvider } from '@mui/material/styles'

interface ThemeProviderProps {
	children: ReactNode
}

const AppThemeProvider: FC<ThemeProviderProps> = ({ children }) => (
	<ThemeProvider theme={createAppTheme(false)}>
		{children}
	</ThemeProvider>
)

export default AppThemeProvider